import { createSlice } from '@reduxjs/toolkit';
import { tokenStorage } from 'local-storage/globle';

import {
  signInReducers,
  createResetPasswordCodeReducers,
  verifyResetPasswordCodeReducers,
  resetPasswordReducers
} from './auth.reducers';

const initialState = {
  token: tokenStorage().get() ?? tokenStorage('session').get() ?? {},
  signInStatus: '',
  signInMessage: '',
  forgotPasswordStatus: '',
  forgotPasswordMessage: '',
  verifyCodeStatus: '',
  verifyCodeMessage: '',
  resetPasswordStatus: '',
  resetPasswordMessage: '',
  resetPasswordToken: null,
};

const authSlice = createSlice({
  name: 'auth-slice',
  initialState,
  reducers: {
    signOut: (state) => {
      tokenStorage().remove();
      tokenStorage('session').remove();
      state.token = {};
      state.signInStatus = '';
    },
  },
  extraReducers: (builder) => {
    signInReducers(builder);
    createResetPasswordCodeReducers(builder);
    verifyResetPasswordCodeReducers(builder);
    resetPasswordReducers(builder);
  },
});

export const { signOut } = authSlice.actions;
export default authSlice.reducer;
